import { memo, useCallback } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { LineItemClassesCell } from "@components/lineItems/LineItemClassesCell";
import { useUpdateCatalogItem } from "@api/catalogItem.api";
import { CatalogItemRow } from "../catalogItems.types";

export const ClassCell = memo(function ClassCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemRow, unknown>) {
    const updateCatalogItem = useUpdateCatalogItem();
    const item = row.original;

    const handleClassesChange = useCallback(
        async (classIds: string[]) => {
            await updateCatalogItem.mutateAsync({
                catalogItemId: item.id,
                body: { classIds },
            });
        },
        [updateCatalogItem, item.id],
    );

    return (
        <LineItemClassesCell
            lineItem={item}
            onUpdateClasses={handleClassesChange}
        />
    );
});
